import { render } from "./DiagramItem.vue?vue&type=template&id=cfc7304a&scoped=true&bindings={}"
import script from "./DiagramItem.vue?vue&type=script&lang=ts"
export * from "./DiagramItem.vue?vue&type=script&lang=ts"

import "./DiagramItem.vue?vue&type=style&index=0&id=cfc7304a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cfc7304a"

export default script